<template>
  <div id="app">
    <!-- 页面路由总出口 -->
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted(){
    document.title = process.env.VUE_APP_PROJECT_NAME || 'demo'
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";
</style>
